import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { retailerContactRouter } from './routing/retailerContactRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'retailer-contact',
  totem: {
    tool: 'retailer-contact-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  routers: {
    scoped: [retailerContactRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [],
}

export default definition
